import { Head } from "@inertiajs/react"
import { useEffect } from "react"
import { router } from "@inertiajs/react"

export default function Search() {
  useEffect(() => {
    router.visit("/files", { replace: true })
  }, [])

  return (
    <>
      <Head title="Search" />
      <div className="flex flex-1 items-center justify-center">
        <p className="text-sm text-muted-foreground">Redirecting...</p>
      </div>
    </>
  )
}
